
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-phone)"}},[_c('path',{attrs:{"d":"M23.347 17.614l-3.35-3.35c-1.196-1.196-3.23-.717-3.708.838-.359 1.076-1.555 1.674-2.631 1.435-2.393-.598-5.622-3.708-6.22-6.22-.36-1.077.359-2.273 1.435-2.632 1.555-.478 2.034-2.512.837-3.708L6.361.628c-.957-.837-2.392-.837-3.23 0L.86 2.901c-2.273 2.392.239 8.732 5.861 14.354s11.962 8.253 14.354 5.861l2.273-2.273c.837-.957.837-2.392 0-3.23z","fill":"#838383"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-phone"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    